/*
 * ===============================================================================================================
 *                                Copyright 2020, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { makeStyles } from 'tss-react/mui';
import { Palette, Tokens } from '@jda/lui-common-component-library-mui5';

const fontStyle = {
  light: {
    color: Palette.colors.common.white,
  },
  dark: {
    color: Palette.colors.common.white,
  }
};

const useStyle = makeStyles()(theme => ({
  root: {
    margin: theme.spacing(0, 2),
    background: 'transparent !important',
    position: "relative",
    overflow: "hidden",
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
  },
  transparent: {
    background: 'transparent !important'
  },
  tabs: {
    borderBottom: `1px solid ${theme.palette.mode === 'light' ? 'rgba(0, 0, 51, 0.06)' : 'rgba(206, 206, 250, 0.0902)'}`,
  },
  text: {
    // lineHeight: 1.75,
    borderBottomWidth: '0px !important',
    fontSize: Tokens.sizing.textLarge,
    color: theme.palette.text.primary,
  },
  selected: {
    color: fontStyle[theme.palette.mode].color
  },
  headingAlignment: {
    color: theme.palette.text.primary,
    fontSize: Tokens.spacing['$sp-8-5'],
    marginBottom: Tokens.spacing['$sp-4'],
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  exportingMessageBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px',
    borderRadius: '5px',
    boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.1)',
    marginBottom: Tokens.spacing['$sp-4']
  },
  aligning: {
    display: 'flex',
    alignItems: 'center',
  },
  exportingMessageBoxMain: {
    backgroundColor: theme.palette.primary.main,
  },
  exportingMessageBoxSuccess: {
    backgroundColor: '#1F9F55',
  },
  exportingIcon: {
    fontSize: `${theme.typography.pxToRem(28)}`,
    transform: 'rotate(45deg)',
    marginRight: '15px'
  },
  checkedIcon: {
    fontSize: `${theme.typography.pxToRem(28)}`,
    marginRight: Tokens.spacing['$sp-4']
  },
  goToButton: {
    color: theme.palette.common.white,
    borderColor: theme.palette.common.white,
    padding: '6px 10px'
  },
  closeButton: {
    padding: '3px',
    marginLeft: Tokens.spacing['$sp-4'],
    '& svg': {
      fontSize: `${theme.typography.pxToRem(18)}`,
      display: 'flex',
      color: theme.palette.common.white
    }
  },
  exportingMessage: {
    color: theme.palette.common.white,
  },
  tabPanelAlignment: {
    marginTop: Tokens.spacing['$sp-2'],
    marginLeft: Tokens.spacing['$sp-2'],
    backgroundColor: theme.palette.background.default
  },
  loader: {
    textAlign: "center",
    alignItems: "center",
    color: fontStyle[theme.palette.mode].color,
    '& .MuiCircularProgress-colorPrimary': {
      color: fontStyle[theme.palette.mode].color
    },
    padding: Tokens.spacing['$sp-3']
  },
  tabPanel: {
    minHeight: 0,
    flex: 1,
  },
  locationDialog: {
    '& .MuiDialogContent-root': {
      padding: '0 !important'
    }
  },
  locationDialogToolbar: {
    height: '48px',
    padding: theme.spacing(0, 1.5),
    backgroundColor: theme.palette.grey[50],
    display: 'flex',
    alignItems: 'center'
  },
  locationSearchField: {
    width: 320,
    borderBottomStyle: 'solid',
    borderBottomWidth: Tokens.spacing['$sp-0-25'],
    borderBottomColor: theme.palette.text.secondary
  },
  locationList: {
    padding: '0 !important',
    overflowY: 'auto'
  },
  locationPagination: {
    '& > *': {
      boxSizing: 'border-box',
      paddingTop: 0,
      paddingBottom: 0,
      paddingRight: 0
    }
  },
  locationDialogLoader: {
    padding: Tokens.spacing['$sp-3']
  },
  buttonGroup: {
    '& .MuiTypography-colorPrimary': {
      color: theme.palette.common.white,
    },
    '& .MuiButton-outlinedPrimary': {
      borderColor: theme.palette.common.white,
      // backgroundColor: '#025583',
    },
    '& .MuiButton-containedPrimary': {
      border: `1px solid ${theme.palette.common.white}`,
      backgroundColor: '#025583',
    }
  }
}));
export default useStyle;
